/**
 * List of endpoints.
 */
export const endpoints = {
  LOGIN_WITH_CREDENTIALS: '/api/auth/login',
  REFRESH_TOKEN: '/api/auth/refresh-token',
  LOGOUT: '/api/auth/logout',
};
